export default __webpack_public_path__ + "static/media/accordian-arrow-up.2c495fdc.svg";